export default __webpack_public_path__ + "static/media/05_PackProper.f39c4a17.png";